import EditFacility from "layouts/Facilities/EditFacility";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import CreateTherapistType from "CinicComponents/TherapistType/CreateTherapistType";
import CreateEmployeeType from "CinicComponents/EmployeeType/CreateEmployeeType";
import EditTherapistType from "CinicComponents/TherapistType/EditTherapistType";
import FacilityTypes from "layouts/FacilityTypes";
import Facilities from "layouts/Facilities";
import Sessions from "layouts/Sessions";
import SessionDetails from "layouts/Sessions/SessionDetails";
import AccountingSessions from "layouts/AccountingSessions/";
import PatientAccountingSessions from "layouts/AccountingSessions/PatientViews/index";
import AccountingSessionDetails from "layouts/AccountingSessions/AccountingSessionDetails";
import PatientSessionDetails from "layouts/AccountingSessions/PatientViews/PatientSessionDetails";
import AccountingEntries from "layouts/AccountingEntries/";
import AccountingEntriesTable from "layouts/AccountingEntries/AccountingEntriesTable";
import AppointmentDayDetails from "layouts/Appointments/AppointmentDays/AppointmentDayDetails";
import AppointmentDayDetailsSimple from "layouts/Appointments/AppointmentDaysSimple/AppDayDetailsSimple";
import AppointmentDaySelectHour from "layouts/Appointments/AppointmentDaySelectHour";
import AppointmentHourDetails from "layouts/Appointments/AppointmentHourDetails";
import CreateAppointment from "layouts/Appointments/CreateAppointment";
import PatientAppointmentRequests from "layouts/Appointments/PatientAppointmentRequests";
// @mui icons
import Icon from "@mui/material/Icon";
import PrivateRoute from "CinicComponents/Auth/PrivateRoute";
import AccountingRoute from "CinicComponents/Auth/AccountingRoute";
import AppointmentRoute from "CinicComponents/Auth/AppointmentRoute";
import StaffRoute from "CinicComponents/Auth/StaffRoute";
import AdminRoute from "CinicComponents/Auth/AdminRoute";

import Appointments from "layouts/Appointments";

import ClinicDash from "layouts/ClinicDash";

import CreateMultiPackage from "layouts/AccountingSessions/Packages/CreateMultiPackage";
import CreateDomesticStay from "layouts/DomesticStays/CreateDomesticStay";
import DomesticStayDetails from "layouts/DomesticStays/DomesticStayDetails";
import DomesticStaysTable from "layouts/DomesticStays/DomesticStaysTable";

import CreateContract from "layouts/Contracts/CreateContract";
import ContractsTable from "layouts/Contracts/ContractsTable";
import ContractDetails from "layouts/Contracts/ContractDetails";

import PackageDetails from "layouts/AccountingSessions/Packages/PackageDetails";

import CreateAccountingEntry from "CinicComponents/Accounting/CreateAccountingEntry";
import TherapistTypeList from "CinicComponents/TherapistType/TherapistTypeList";
import EmployeeTypeList from "CinicComponents/EmployeeType/EmployeeTypeList";
import EditEmployeeType from "CinicComponents/EmployeeType/EditEmployeeType";
import EditFacilityType from "layouts/FacilityTypes/EditFacilityType";
import AccountingEntryList from "../src/CinicComponents/Accounting/AccountingEntryList";
import ManageUsers from "layouts/ManageUsers";
import UserDetails from "layouts/ManageUsers/UserDetails";
import CreateUser from "layouts/ManageUsers/CreateUser";

import UserBalances from "layouts/AccountingEntries/UserBalances";

import UserNotifications from "layouts/UserNotifications";
import Logs from "layouts/Logs";
import PatientAnalytics from "layouts/Analytics/PatientAnalyitcs";
import CreatePatientProgram from "layouts/PatientPrograms/CreatePatientProgram";
import PatientProgramsTable from "layouts/PatientPrograms/PatientProgramsTable";
import PatientProgramDetails from "layouts/PatientPrograms/PatientProgramDetails";
import Feedback from "layouts/Appointments/Feedback";
import FeedbackForm from "layouts/Appointments/Feedback/feedbackForm";
import FeedbackStatistics from "layouts/Statistics/FeedbackStatistics";
import AccountingSessionsStatistics from "layouts/Statistics/AccountingSessionsStatistics";
import FeedbackFormAr from "layouts/Appointments/Feedback/feedbackFormAr";
import UserStatistics from "layouts/Statistics/UserStatistics";
// import PatientList from "layouts/ManageUsers/UserDetails/components/Patients/PatientList";
// import PatientEntries from "layouts/ManageUsers/UserDetails/components/Patients/PatientEntries";
// import CreateEntry from "layouts/ManageUsers/UserDetails/components/Patients/CreateEntry";
import CreateEntry from "layouts/Patients/CreateEntry";
import PatientList from "layouts/Patients/PatientList";
import PatientEntries from "layouts/Patients/PatientEntries";
import AccountingSessionWithNoPatientHistoryEntry from "layouts/Statistics/AccountingSessionsWithNoPatientHistoryEntry";
import PackagesStatistics from "layouts/Statistics/packagesStatistics";
import PatientAccountingSessionEnteries from "layouts/AccountingSessions/PatientEnteries";
import AccSessionPackageStats from "layouts/Statistics/accSessionPackageStats";
import AccountingEntryStatistics from "layouts/Statistics/AccountingEntryStatistics";
import ReceiptPage from "layouts/receipts/receipt-page";

import SingleSessionsPage from "layouts/AccountingSessions/SingleSessions/SingleSessionsPage";
import PackagesPage from "layouts/AccountingSessions/Packages/PackagesPage";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small"> dashboard </Icon>,
    route: "/dashboard",
    component: (
      <PrivateRoute>
        <ClinicDash />
      </PrivateRoute>
    ),
  },

  {
    type: "collapse",
    name: "Logs",
    key: "Logs",
    icon: <Icon fontSize="small">Logs</Icon>,
    route: "/Logs/",
    component: (
      <AdminRoute>
        {" "}
        <Logs />
      </AdminRoute>
    ),
  },

  {
    type: "collapse",
    name: "Analytics",
    key: "Analytics",
    icon: <Icon fontSize="small">Analytics</Icon>,
    route: "/Analytics/Patients/",
    component: (
      <AdminRoute>
        {" "}
        <PatientAnalytics />
      </AdminRoute>
    ),
  },

  {
    type: "collapse",
    name: "Notifications",
    key: "Notifications",
    icon: <Icon fontSize="small">Notifications</Icon>,
    route: "/Notifications/",
    component: (
      <PrivateRoute>
        {" "}
        <UserNotifications />
      </PrivateRoute>
    ),
  },

  // Contracts

  {
    type: "collapse",
    name: "Create Contract",
    key: "CreateContract",
    icon: <Icon fontSize="small">CreateContract</Icon>,
    route: "/Contracts/CreateContract",
    component: (
      <AccountingRoute>
        {" "}
        <CreateContract />
      </AccountingRoute>
    ),
  },
  {
    type: "collapse",
    name: "Contracts Table",
    key: "ContractsTable",
    icon: <Icon fontSize="small">ContractsTable</Icon>,
    route: "/Contracts/Table",
    component: (
      <AccountingRoute>
        {" "}
        <ContractsTable />
      </AccountingRoute>
    ),
  },
  {
    type: "collapse",
    name: "Contract Details",
    key: "ContractDetails",
    icon: <Icon fontSize="small">ContractDetails</Icon>,
    route: "/Contracts/Details",
    component: (
      <AccountingRoute>
        {" "}
        <ContractDetails />
      </AccountingRoute>
    ),
  },

  // Domestic Stays
  {
    type: "collapse",
    name: "Create Domestic Stay",
    key: "CreateDomesticStay",
    icon: <Icon fontSize="small">CreateDomesticStay</Icon>,
    route: "/DomesticStays/CreateDomesticStay",
    component: (
      <AccountingRoute>
        {" "}
        <CreateDomesticStay />
      </AccountingRoute>
    ),
  },
  {
    type: "collapse",
    name: "Domestic Stays Table",
    key: "DomesticStaysTable",
    icon: <Icon fontSize="small">DomesticStaysTable</Icon>,
    route: "/DomesticStays/Table",
    component: (
      <AccountingRoute>
        {" "}
        <DomesticStaysTable />
      </AccountingRoute>
    ),
  },
  {
    type: "collapse",
    name: "Domestic Stay Details",
    key: "DomesticStayDetails",
    icon: <Icon fontSize="small">DomesticStayDetails</Icon>,
    route: "/DomesticStays/Details",
    component: (
      <AccountingRoute>
        {" "}
        <DomesticStayDetails />
      </AccountingRoute>
    ),
  },

  //accounting
  {
    type: "collapse",
    name: "Accounting Entry List",
    key: "AccountingEntryList",
    icon: <Icon fontSize="small"> Accounting List </Icon>,
    route: "/accountingEntryList",
    component: (
      <AccountingRoute>
        {" "}
        <AccountingEntryList />
      </AccountingRoute>
    ),
  },
  {
    type: "collapse",
    name: "Create Accounting Entry",
    key: "CreateAccountingEntry",
    icon: <Icon fontSize="small"> Accounting List </Icon>,
    route: "/CreateAccountingEntry",
    component: (
      <AccountingRoute>
        {" "}
        <CreateAccountingEntry />
      </AccountingRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "EditAccountingEntry",
  //   key: "EditAccountingEntry",
  //   icon: <Icon fontSize="small" > Accounting List </Icon>,
  //   route: "/editAccountingEntry/:id",
  //   component: <EditAccountingEntry />,
  // },
  // Therapists
  {
    type: "collapse",
    name: "Therapist Type List",
    key: "TherapistTypeList",
    icon: <Icon fontSize="small"> create TherapistType </Icon>,
    route: "/TherapistTypeList",
    component: (
      <AdminRoute>
        {" "}
        <TherapistTypeList />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Create Therapist Type",
    key: "createTherapistType",
    icon: <Icon fontSize="small"> create TherapistType </Icon>,
    route: "/createTherapistType",
    component: (
      <AdminRoute>
        {" "}
        <CreateTherapistType />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Edit Therapist Type",
    key: "EditTherapistType",
    icon: <Icon fontSize="small"> Edit TherapistType </Icon>,
    route: "/EditTherapistType/:id",
    component: (
      <AdminRoute>
        {" "}
        <EditTherapistType />
      </AdminRoute>
    ),
  },
  // employees
  {
    type: "collapse",
    name: "Create Employee Type",
    key: "createEmployeeType",
    icon: <Icon fontSize="small"> create EmployeeType </Icon>,
    route: "/createEmployeeType",
    component: (
      <AdminRoute>
        {" "}
        <CreateEmployeeType />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Edit Employee Type",
    key: "editEmployeeType",
    icon: <Icon fontSize="small"> edit EmployeeType </Icon>,
    route: "/editEmployeeType/:id",
    component: (
      <AdminRoute>
        {" "}
        <EditEmployeeType />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Employee Type List",
    key: "EmployeeTypeList",
    icon: <Icon fontSize="small"> EmployeeTypeList </Icon>,
    route: "/EmployeeTypeList",
    component: (
      <AdminRoute>
        {" "}
        <EmployeeTypeList />
      </AdminRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Facility Types",
  //   key: "FacilityTypes",
  //   icon: <Icon fontSize="small">Facility Types</Icon>,
  //   route: "/FacilityTypes",
  //   component: (
  //     <AdminRoute>
  //       {" "}
  //       <FacilityTypes />
  //     </AdminRoute>
  //   ),
  // },

  // // facilities
  // {
  //   type: "collapse",
  //   name: "Facilities",
  //   key: "Facilities",
  //   icon: <Icon fontSize="small">Facilities</Icon>,
  //   route: "/Facilities",
  //   component: (
  //     <AdminRoute>
  //       {" "}
  //       <Facilities />
  //     </AdminRoute>
  //   ),
  // },
  {
    type: "collapse",
    name: "Edit Facility",
    key: "EditFacility",
    icon: <Icon fontSize="small">Edit Facilitie </Icon>,
    route: "/EditFacility/:id",
    component: (
      <AdminRoute>
        {" "}
        <EditFacility />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Edit Facility Type",
    key: "editFacilityType",
    icon: <Icon fontSize="small">Edit Facilitie </Icon>,
    route: "/editFacilityType/:id",
    component: (
      <AdminRoute>
        {" "}
        <EditFacilityType />
      </AdminRoute>
    ),
  },
  // sessions
  {
    type: "collapse",
    name: "Sessions",
    key: "Sessions",
    icon: <Icon fontSize="small">Sessions</Icon>,
    route: "/Sessions",
    component: (
      <AdminRoute>
        {" "}
        <Sessions />
      </AdminRoute>
    ),
  },

  {
    type: "collapse",
    name: "Session Details",
    key: "SessionDetails",
    icon: <Icon fontSize="small">SessionDetails</Icon>,
    route: "/Sessions/Details",
    component: (
      <AdminRoute>
        <SessionDetails />
      </AdminRoute>
    ),
  },

  // Patient Appointment Requests

  {
    type: "collapse",
    name: "Patient Appointment Requests",
    key: "PatientAppointmentRequests",
    icon: <Icon fontSize="small">PatientAppointmentRequests</Icon>,
    route: "/Appointments/PatientAppointmentRequests",
    component: (
      <AppointmentRoute>
        <PatientAppointmentRequests />
      </AppointmentRoute>
    ),
  },
  {
    type: "collapse",
    name: "Feedback Form",
    key: "FeedbackForm",
    icon: <Icon fontSize="small">Feedback Form</Icon>,
    route: "/Appointments/FeedbackForm/:tenantId",
    component: <FeedbackForm />,
  },
  {
    type: "collapse",
    name: "Feedback Statistics",
    key: "FeedbackStatistics",
    icon: <Icon fontSize="small">Feedback Statistics</Icon>,
    route: "/Appointments/FeedbackStatistics",
    component: (
      <AdminRoute>
        {" "}
        <FeedbackStatistics />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "User Statistics",
    key: "UserStatistics",
    icon: <Icon fontSize="small">Feedback Statistics</Icon>,
    route: "/Appointments/UserStatistics",
    component: (
      <AdminRoute>
        <UserStatistics />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Packages Statistics",
    key: "PackagesStatistics",
    icon: <Icon fontSize="small">Feedback Statistics</Icon>,
    route: "/Appointments/PackagesStatistics",
    component: (
      <AdminRoute>
        <PackagesStatistics />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Accounting Entries Statistics",
    key: "AccountingEntriesStatistics",
    icon: <Icon fontSize="small">Accounting Enteries Statistics</Icon>,
    route: "/AccountingEntriesStatistics",
    component: (
      <AdminRoute>
        <AccountingEntryStatistics />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Accounting Sessions Packages Statistics",
    key: "AccountingSessionsPackagesStatistics",
    icon: <Icon fontSize="small">Feedback Statistics</Icon>,
    route: "/Appointments/AccountingSessionsPackagesStatistics",
    component: (
      <AdminRoute>
        <AccSessionPackageStats />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Accounting Sessions Statistics",
    key: "AccountingSessionsStatistics",
    icon: <Icon fontSize="small">Accounting Sessions Statistics</Icon>,
    route: "/Appointments/AccountingSessionsStatistics",
    component: (
      <AdminRoute>
        <AccountingSessionsStatistics />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Accounting Session With No Patient History Entry",
    key: "AccountingSessionWithNoPatientHistoryEntry",
    icon: <Icon fontSize="small">Accounting Sessions With No Patient History Entry</Icon>,
    route: "/Appointments/AccountingSessionWithNoPatientHistoryEntry",
    component: (
      <AdminRoute>
        <AccountingSessionWithNoPatientHistoryEntry />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Feedback",
    key: "Feedback",
    icon: <Icon fontSize="small">Feedback</Icon>,
    route: "/Appointments/Feedback",
    component: (
      <AdminRoute>
        <Feedback />
      </AdminRoute>
    ),
  },
  {
    type: "collapse",
    name: "Create Patient Program",
    key: "CreatePatientProgram",
    icon: <Icon fontSize="small">CreatePatientProgram</Icon>,
    route: "/PatientPrograms/CreatePatientProgram",
    component: (
      <AppointmentRoute>
        {" "}
        <CreatePatientProgram />
      </AppointmentRoute>
    ),
  },

  {
    type: "collapse",
    name: "Patient Program Details",
    key: "PatientProgramDetails",
    icon: <Icon fontSize="small">PatientProgramDetails</Icon>,
    route: "/PatientPrograms/Details",
    component: (
      <AppointmentRoute>
        {" "}
        <PatientProgramDetails />
      </AppointmentRoute>
    ),
  },

  {
    type: "collapse",
    name: "Manage Patient Programs",
    key: "ManagePatientPrograms",
    icon: <Icon fontSize="small">ManagePatientPrograms</Icon>,
    route: "/PatientPrograms/ManagePatientPrograms",
    component: (
      <AppointmentRoute>
        {" "}
        <PatientProgramsTable />
      </AppointmentRoute>
    ),
  },

  //Appointments

  {
    type: "collapse",
    name: "Appointments",
    key: "Appointments",
    icon: <Icon fontSize="small">Appointments</Icon>,
    route: "/Appointments",
    component: (
      <StaffRoute>
        {" "}
        <Appointments />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Appointment Day Details Simple",
    key: "AppointmentDayDetailsSimple",
    icon: <Icon fontSize="small">AppointmentDayDetailsSimple</Icon>,
    route: "/Appointments/AppDayDetailsSimple",
    component: (
      <StaffRoute>
        {" "}
        <AppointmentDayDetailsSimple />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Appointment Day Select Hour",
    key: "AppointmentDaySelectHour",
    icon: <Icon fontSize="small">AppointmentDaySelectHour</Icon>,
    route: "/Appointments/AppointmentDaySelectHour",
    component: (
      <StaffRoute>
        {" "}
        <AppointmentDaySelectHour />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Patient Accounting Session Enteries",
    key: "PatientAccountingSessionEnteries",
    icon: <Icon fontSize="small">PatientAccountingSessionEnteries</Icon>,
    route: "/Appointments/PatientAccountingSessionEnteries",
    component: (
      <StaffRoute>
        {" "}
        <PatientAccountingSessionEnteries />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Appointment Day Details",
    key: "AppointmentDayDetails",
    icon: <Icon fontSize="small">AppDayDetails</Icon>,
    route: "/Appointments/AppDayDetails",
    component: (
      <AppointmentRoute>
        {" "}
        <AppointmentDayDetails />
      </AppointmentRoute>
    ),
  },

  {
    type: "collapse",
    name: "Appointment Hour Details",
    key: "AppointmentHourDetails",
    icon: <Icon fontSize="small">AppHourDetails</Icon>,
    route: "/Appointments/AppHourDetails",
    component: (
      <AppointmentRoute>
        {" "}
        <AppointmentHourDetails />
      </AppointmentRoute>
    ),
  },

  {
    type: "collapse",
    name: "Create Appointment",
    key: "CreateAppointment",
    icon: <Icon fontSize="small">CreateAppointment</Icon>,
    route: "/Appointments/CreateAppointment",
    component: (
      <AppointmentRoute>
        {" "}
        <CreateAppointment />
      </AppointmentRoute>
    ),
  },

  // Accounting Sessions
  {
    type: "collapse",
    name: "Accounting Sessions",
    key: "AccountingSessions",
    icon: <Icon fontSize="small">AccountingSessions</Icon>,
    route: "/AccountingSessions/",
    component: (
      <StaffRoute>
        {" "}
        <AccountingSessions />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Accounting Session Details",
    key: "AccountingSessionDetails",
    icon: <Icon fontSize="small">AccountingSessionDetails</Icon>,
    route: "/AccountingSessions/Details",
    component: (
      <StaffRoute>
        {" "}
        <AccountingSessionDetails />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Accounting Session Details",
    key: "AccountingSessionDetails",
    icon: <Icon fontSize="small">AccountingSessionDetails</Icon>,
    route: "/Users/Options/AccSessionDetails",
    component: (
      <StaffRoute>
        {" "}
        <AccountingSessionDetails />
      </StaffRoute>
    ),
  },

  // Packages

  {
    type: "collapse",
    name: "Create Package",
    key: "CreateMultiPackage",
    icon: <Icon fontSize="small">CreateMultiPackage</Icon>,
    route: "/AccountingSessions/Packages/CreateMultiPackage",
    component: (
      <AccountingRoute>
        {" "}
        <CreateMultiPackage />
      </AccountingRoute>
    ),
  },

  {
    type: "collapse",
    name: "Package Details",
    key: "PackageDetails",
    icon: <Icon fontSize="small">PackageDetails</Icon>,
    route: "/AccountingSessions/Packages/Details",
    component: (
      <AccountingRoute>
        {" "}
        <PackageDetails />
      </AccountingRoute>
    ),
  },

  {
    type: "collapse",
    name: "Package Details",
    key: "PackageDetails",
    icon: <Icon fontSize="small">PackageDetails</Icon>,
    route: "/Users/Options/PackageDetails",
    component: (
      <StaffRoute>
        {" "}
        <PackageDetails />
      </StaffRoute>
    ),
  },

  // Patient Accounting Sessions

  {
    type: "collapse",
    name: "Patient Accounting Sessions",
    key: "PatientAccountingSessions",
    icon: <Icon fontSize="small">Patient Accounting Sessions</Icon>,
    route: "/PatientAccountingSessions/",
    component: (
      <PrivateRoute>
        {" "}
        <PatientAccountingSessions />
      </PrivateRoute>
    ),
  },

  {
    type: "collapse",
    name: "Patient Session Details",
    key: "PatientSessionDetails",
    icon: <Icon fontSize="small">Patient Session Details</Icon>,
    route: "/PatientAccountingSessions/Details",
    component: <PatientSessionDetails />,
    component: (
      <PrivateRoute>
        {" "}
        <PatientSessionDetails />
      </PrivateRoute>
    ),
  },

  {
    type: "collapse",
    name: "Balance Entries",
    key: "BalanceEntries",
    icon: <Icon fontSize="small">BalanceEntries</Icon>,
    route: "/BalanceEntries/",
    component: <UserBalances />,
  },

  // Accounting Entries

  {
    type: "collapse",
    name: "Accounting Entries",
    key: "AccountingEntries",
    icon: <Icon fontSize="small">AccountingEntries</Icon>,
    route: "/AccountingEntries/CreateNewEntry",
    component: (
      <AccountingRoute>
        {" "}
        <AccountingEntries />
      </AccountingRoute>
    ),
  },

  {
    type: "collapse",
    name: "Accounting Entries Table",
    key: "AccountingEntriesTable",
    icon: <Icon fontSize="small">AccountingEntriesTable</Icon>,
    route: "/AccountingEntries/Table",
    component: (
      <AccountingRoute>
        {" "}
        <AccountingEntriesTable />
      </AccountingRoute>
    ),
  },

  // ManageUsers

  {
    type: "collapse",
    name: "Create User",
    key: "CreateUser",
    icon: <Icon fontSize="small">CreateUser</Icon>,
    route: "/CreateUser",
    component: (
      <StaffRoute>
        {" "}
        <CreateUser />
      </StaffRoute>
    ),
    // component:<CreateUser />,
  },
  {
    type: "collapse",
    name: "Patient History",
    key: "PatientList",
    icon: <Icon fontSize="small">PatientList</Icon>,
    route: "/PatientList",
    component: (
      <StaffRoute>
        {" "}
        <PatientList />
      </StaffRoute>
    ),
  },
  {
    type: "collapse",
    name: "Patient Entries",
    key: "PatientEntries",
    icon: <Icon fontSize="small">PatientEntries</Icon>,
    route: "/PatientEntries/:id",
    component: (
      <StaffRoute>
        {" "}
        <PatientEntries />
      </StaffRoute>
    ),
  },
  {
    type: "collapse",
    name: "Create Entry",
    key: "CreateEntry",
    icon: <Icon fontSize="small">CreateEntry</Icon>,
    route: "/CreateEntry/:id",
    component: (
      <StaffRoute>
        {" "}
        <CreateEntry />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "Manage Users",
    key: "ManageUsers",
    icon: <Icon fontSize="small">user</Icon>,
    route: "/Users",
    component: (
      <StaffRoute>
        {" "}
        <ManageUsers />
      </StaffRoute>
    ),
  },

  {
    type: "collapse",
    name: "User Options",
    key: "UserOptions",
    icon: <Icon fontSize="small">user</Icon>,
    route: "/Users/Options",
    component: (
      <StaffRoute>
        {" "}
        <UserDetails />
      </StaffRoute>
    ),
  },

  // {
  //   type: "collapse",
  //   name: "ManageUsers",
  //   key: "ManageUsers",
  //   icon: <Icon fontSize="small" >user</Icon>,
  //   route: "/Users",
  //   component: <ManageUsers />,

  // },

  // {
  //   type: "collapse",
  //   name: "Sessions",
  //   key: "Sessions",
  //   icon: <Icon fontSize="small" >user</Icon>,
  //   route: "/Users/Options",
  //   component: <UserDetails />,

  // },

  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small"> login </Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small"> assignment </Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },

  {
    type: "collapse",
    name: "Receipts",
    key: "Receipts",
    icon: <Icon fontSize="small"> receipt </Icon>,
    route: "/receipts",
    component: (
      <AdminRoute>
        {" "}
        <ReceiptPage />
      </AdminRoute>
    ),
    // component:<CreateUser />,
  },
  {
    type: "collapse",
    name: "Single Sessions",
    key: "SingleSessions",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/AccountingSessions/Single",
    component: (
      <StaffRoute>
        <SingleSessionsPage />
      </StaffRoute>
    ),
  },

  // Packages Page
  {
    type: "collapse",
    name: "Packages",
    key: "Packages",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/AccountingSessions/Packages",
    component: (
      <StaffRoute>
        <PackagesPage />
      </StaffRoute>
    ),
  },

  // {
  //   type: "collapse",
  //   name: "TherapistTypeList",
  //   key: "TherapistTypeList",
  //   icon: <Icon fontSize="small" > create TherapistType </Icon>,
  //   route: "/TherapistTypeList",
  //   component:<SubAdminRoute> <TherapistTypeList /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "createTherapistType",
  //   key: "createTherapistType",
  //   icon: <Icon fontSize="small" > create TherapistType </Icon>,
  //   route: "/createTherapistType",
  //   component:<SubAdminRoute> <CreateTherapistType /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "EditTherapistType",
  //   key: "EditTherapistType",
  //   icon: <Icon fontSize="small" > Edit TherapistType </Icon>,
  //   route: "/EditTherapistType/:id",
  //   component:<SubAdminRoute> <EditTherapistType /></SubAdminRoute>,

  // },
  // // employees
  // {
  //   type: "collapse",
  //   name: "createEmployeeType",
  //   key: "createEmployeeType",
  //   icon: <Icon fontSize="small" > create EmployeeType </Icon>,
  //   route: "/createEmployeeType",
  //   component:<SubAdminRoute> <CreateEmployeeType /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "editEmployeeType",
  //   key: "editEmployeeType",
  //   icon: <Icon fontSize="small" > edit EmployeeType </Icon>,
  //   route: "/editEmployeeType/:id",
  //   component:<SubAdminRoute> <EditEmployeeType /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "EmployeeTypeList",
  //   key: "EmployeeTypeList",
  //   icon: <Icon fontSize="small" > EmployeeTypeList </Icon>,
  //   route: "/EmployeeTypeList",
  //   component:<SubAdminRoute> <EmployeeTypeList /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "FacilityTypes",
  //   key: "FacilityTypes",
  //   icon: <Icon fontSize="small" >Facility Types</Icon>,
  //   route: "/FacilityTypes",
  //   component:<SubAdminRoute> <FacilityTypes /></SubAdminRoute>,

  // },

  // // facilities
  // {
  //   type: "collapse",
  //   name: "Facilities",
  //   key: "Facilities",
  //   icon: <Icon fontSize="small" >Facilities</Icon>,
  //   route: "/Facilities",
  //   component:<SubAdminRoute> <Facilities /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "EditFacility",
  //   key: "EditFacility",
  //   icon: <Icon fontSize="small" >Edit Facilitie </Icon>,
  //   route: "/EditFacility/:id",
  //   component:<SubAdminRoute> <EditFacility /></SubAdminRoute>,

  // },
  // {
  //   type: "collapse",
  //   name: "editFacilityType",
  //   key: "editFacilityType",
  //   icon: <Icon fontSize="small" >Edit Facilitie </Icon>,
  //   route: "/editFacilityType/:id",
  //   component:<SubAdminRoute> <EditFacilityType /></SubAdminRoute>,

  // },
  // // sessions
  // {
  //   type: "collapse",
  //   name: "Sessions",
  //   key: "Sessions",
  //   icon: <Icon fontSize="small" >Sessions</Icon>,
  //   route: "/Sessions",
  //   component:<SubAdminRoute> <Sessions /></SubAdminRoute>,

  // },

  // {
  //   type: "collapse",
  //   name: "SessionDetails",
  //   key: "SessionDetails",
  //   icon: <Icon fontSize="small" >SessionDetails</Icon>,
  //   route: "/Sessions/Details",
  //   component:<SubAdminRoute> <SessionDetails /></SubAdminRoute>,

  // },
];

export default routes;
